// Rascunho de formulário no aparelho. No tablet o Android pode fechar o
// navegador (ao abrir a câmera, ao trocar de app) e a aba volta recarregada:
// sem isto, tudo o que foi preenchido some. Guarda só neste navegador, vale
// por algumas horas e é apagado ao salvar ou cancelar.
const VALIDADE_MS = 6 * 60 * 60 * 1000;

export function lerRascunho(chave, validadeMs = VALIDADE_MS) {
  try {
    const bruto = localStorage.getItem(`rascunho:${chave}`);
    if (!bruto) return null;
    const r = JSON.parse(bruto);
    if (!r?.em || Date.now() - r.em > validadeMs) { localStorage.removeItem(`rascunho:${chave}`); return null; }
    return r.valor;
  } catch { return null; }
}

export function gravarRascunho(chave, valor) {
  try { localStorage.setItem(`rascunho:${chave}`, JSON.stringify({ em: Date.now(), valor })); } catch { /* sem espaço/privado */ }
}

export function apagarRascunho(chave) {
  try { localStorage.removeItem(`rascunho:${chave}`); } catch { /* nada */ }
}
